import axios from 'axios';

const accessToken: string =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI2NmI2MWZlMjBiNGJkZmViYTQ4MWVhYzUiLCJlbWFpbCI6InN3YWdnZXJAa2FuZW1hb25saW5lLmNvbSIsImlhdCI6MTcyMzIxMTc0NiwiZXhwIjoxNzM4NzYzNzQ2fQ.pp3N9TlJeL5ySWOhY3Na3dUFx_bmK-DIqvbgdg-ZhAo';

const providerInstance = axios.create({
  baseURL: 'https://kanema.staticcomputersinc.com/api',
  responseType: 'json',
  headers: {
    Authorization: `Bearer ${accessToken}`,
  },
});

// Logging request details
providerInstance.interceptors.request.use(request => {
  console.log('Starting Request', {
    method: request.method,
    url: request.url,
    headers: request.headers,
    data: request.data,
  });
  return request;
});

export { providerInstance as ProviderInstance };